<template>
  <carousel
    :perPage="1"
    :autoplay="true"
    :autoplayHoverPause="true"
    :paginationEnabled="false"
    :autoplayTimeout="3000"
    :loop="true"
    :navigationEnabled="true"
    navigationNextLabel="Next"
    navigationPrevLabel="Previous"
    :touchDrag="false"
  >
    <template v-for="(slide, index) in slides">
      <template v-if="index === 0">
        <slide
          class="h-full VueCarousel-slide-active VueCarousel-slide-center"
          v-bind:key="index"
        >
          <div v-html="slide"></div>
        </slide>
      </template>
      <template v-else>
        <slide class="h-full" v-bind:key="index">
          <div v-html="slide"></div>
        </slide>
      </template>
    </template>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "stack",
  props: ["slides"],
  components: {
    Carousel,
    Slide,
  },
};
</script>

<style>
.VueCarousel .VueCarousel-inner {
  /* transition: transform 0s !important; */

  transition: none !important;
}

.VueCarousel-slide {
  /* opacity: 1 !important; */

  transition: all 0.5s ease 0.25s;
  opacity: 0 !important;
}

.VueCarousel-slide-active {
  /* transition: all 0s !important; */
  opacity: 1 !important;
}

.VueCarousel-navigation {
  position: absolute !important;
  top: 0;
  width: 100%;
  left: 0;
  right: 0;
  height: var(--cards-navigation-height) !important;
}

.VueCarousel-navigation-button {
  content: "Button" !important;
  height: auto !important;
  margin: 0 !important;
  position: static !important;
  transform: none !important;
  padding: 0 !important;
  font-family: inherit !important;
  line-height: var(--line-height) !important;
}

.VueCarousel-navigation-button:active,
.VueCarousel-navigation-button:focus {
  outline: 0 !important;
}

.VueCarousel-navigation-prev {
}

.VueCarousel-navigation-next {
  margin-left: 1em !important;
}
</style>
